import {
  Accordion as HeroUIAccordion,
  AccordionItem as HeroUIAccordionItem,
  AccordionItemProps as HeroUIAccordionItemProps,
  AccordionProps as HeroUIAccordionProps,
} from "@heroui/react";
import { clsx } from "clsx";

type Variant = Extract<HeroUIAccordionProps["variant"], "shadow" | "light">;

export type AccordionProps = Omit<
  HeroUIAccordionProps,
  "children" | "itemClasses" | "className" | "variant"
> & {
  items: AccordionItemProps[];
  variant: Variant;
};

export type AccordionItemProps = HeroUIAccordionItemProps & {
  testId?: string;
};

export function Accordion({ items, variant, ...props }: AccordionProps) {
  return (
    <HeroUIAccordion
      {...props}
      itemClasses={{
        base: "py-0 w-full",
        content: "text-sm px-2",
        indicator: "text-xl text-gray-600",
        title: "font-normal text-medium",
        trigger: clsx("flex w-full rounded-lg px-2 py-2", {
          "h-16": variant === "shadow",
        }),
      }}
      variant={variant}
    >
      {items.map((item) => (
        <HeroUIAccordionItem
          {...item}
          key={item.testId}
          data-testid={item.testId}
        >
          {item.children}
        </HeroUIAccordionItem>
      ))}
    </HeroUIAccordion>
  );
}

Accordion.displayName = "Recare.Accordion";
